import { Flex, useTheme } from '@chakra-ui/react';

const StyledPercent = ({
  fontSize,
  fontFamily,
  colorPositive,
  dataTestId = '',
  ...props
}) => {
  const theme = useTheme();

  return (
    <Flex
      fontSize={fontSize || '14px'}
      fontFamily={fontFamily || theme.fonts.semiBold}
      my={0}
      mx='4px'
      color={colorPositive || theme.colors.green || theme.colors.black}
      data-testid={dataTestId}
      {...props}
    />
  );
};

export default StyledPercent;
